import React from "react";

import { ThreeUpCardBlock, ThreeUpCardsBlock as Value } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { Themed } from "../../styles/themes";
import { RichTextStreamBlock } from "../RichTextStreamBlock";
import { SpacerBlock } from "../SpacerBlock";
import { ThreeUpCard } from "./ThreeUpCard";

import styles from "./index.module.scss";

const ThreeUpCardGrid = ({ value }: { value: ThreeUpCardBlock[] }) => (
    <div className={styles.grid}>
        {value.map((card, index) => (
            <ThreeUpCard key={index} value={card} />
        ))}
    </div>
);

const components = {
    rich_text_stream: RichTextStreamBlock,
    spacer: SpacerBlock,
    cards: ThreeUpCardGrid,
};

export const ThreeUpCardsBlock = ({ value }: { value: Value }) => {
    if (!value.items) return <></>;

    return (
        <Themed theme={value.theme} tag="section">
            <StreamField
                tagName={React.Fragment}
                components={components}
                value={value.items}
            />
        </Themed>
    );
};
